import ReactGA from 'react-ga';
import { GACategory } from 'src/types';
import env from '../env';

export const initializeGA = (): void => {
  ReactGA.initialize(env.GA_TRACKING_ID);
};

export const sendGAEvent = (category: GACategory, action: string): void => {
  ReactGA.event({
    category: category,
    action: action,
  });
};
